import { render, staticRenderFns } from "./dialogPermissionInfo.vue?vue&type=template&id=cb0b73cc&"
import script from "./dialogPermissionInfo.vue?vue&type=script&lang=js&"
export * from "./dialogPermissionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports